module.exports = __webpack_public_path__ + "static/media/barilo-title.3fd03eac.webp";